/**
 * {@link https://stitches.dev/docs/api#createStitches}
 */
import { createStitches, defaultThemeMap } from '@stitches/react';
import type * as Stitches from '@stitches/react';

export type { VariantProps } from '@stitches/react';

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  theme: {
    colors: {
      primary: `var(--colors-primary, red)`,
      secondary: `var(--colors-secondary, green)`,
    },
    // space: {},
    // fontSizes: {},
    // fonts: {},
    // fontWeights: {},
    // lineHeights: {},
    // letterSpacings: {},
    // sizes: {},
    // borderWidths: {},
    // borderStyles: {},
    // radii: {},
    // shadows: {},
    // zIndices: {},
    // transitions: {},
  },
  media: {
    // bp1: '(min-width: 640px)',
  },
  utils: {
    mx: (value) => ({ marginLeft: value, marginRight: value }),
    my: (value) => ({ marginTop: value, marginBottom: value }),
    px: (value) => ({ paddingLeft: value, paddingRight: value }),
    py: (value) => ({ paddingTop: value, paddingBottom: value }),
  },
  // prefix: '',
  themeMap: {
    ...defaultThemeMap,
    // width: 'space',
    // height: 'space',
  },
});

export type CSS = Stitches.CSS<typeof config>;
